import { api } from '.'

export const statusApi = api.injectEndpoints({
  endpoints: build => ({
    getStatus: build.query({
      query: () => ({
        url: `/mega_cards/application/online-status/`,
        method: 'GET'
      })
    }),
    getOfflineStatus: build.query({
      query: ({ uuid }) => ({
        url: `/mega_cards/application/${uuid}/offline-status/`,
        method: 'GET'
      })
    }),
    landingAvailability: build.query({
      query: () => ({
        url: `/mega_cards/landing-status/`,
        method: 'GET'
      })
    })
  })
})

export const { useGetStatusQuery, useGetOfflineStatusQuery, useLandingAvailabilityQuery } = statusApi
